import { SOURCE_STORAGE_KEY } from 'components/templates/AuthenticationProvider/Types';
import useQueryStringParams from 'hooks/useQueryStringParams';
import useStorage from 'hooks/useStorage';
import { useEffect } from 'react';
import {
  extractUserSourceDataFromQueryString,
  UserSourceData,
} from 'utils/extractUserSourceDataFromQueryString';

export default function useUserSourceData(): UserSourceData {
  const params = useQueryStringParams();
  const [userSourceData, setUserSourceData] = useStorage<UserSourceData>(SOURCE_STORAGE_KEY, {});

  useEffect(() => {
    const newUserSourceData = extractUserSourceDataFromQueryString(params);

    if (params['~campaign'] && !userSourceData?.utmCampaign) {
      newUserSourceData.utmCampaign = params['~campaign'];
      newUserSourceData.utmSource = 'Facebook';
      newUserSourceData.utmMedium = 'paid advertising';
    }

    setUserSourceData((userSourceData) => {
      return {
        ...userSourceData,
        ...newUserSourceData,
      };
    });
  }, [setUserSourceData, params, userSourceData?.utmCampaign]);

  return userSourceData;
}
